const day3passes = [];

export default day3passes;
